import { render, staticRenderFns } from "./printRecords.vue?vue&type=template&id=16492056"
import script from "./printRecords.vue?vue&type=script&lang=js"
export * from "./printRecords.vue?vue&type=script&lang=js"
import style0 from "./printRecords.vue?vue&type=style&index=0&id=16492056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports